import { Entity } from '@backstage/catalog-model';

export function hasLinks(entity: Entity) {
  return entity?.metadata?.links
    ? Object.keys(entity?.metadata?.links).some(Boolean)
    : false;
}
